import Service from '../Service'
class CurrencyService extends Service {
  constructor() {
    super('')
    this.resource = 'currency'
  }

  createRequestUrl(query) {
    let requestUrl = `${this.resource}?`

    if (query) query = this.encodeQueryValues(query)

    if (query.page)
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`
    if (query.data)
      requestUrl += this.hasParameter(requestUrl)
        ? `&data=${query.data}`
        : `data=${query.data}`

    return requestUrl
  }

  async getCurrency(query) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async deleteCurrency(payload) {
    return await this.delete(payload)
  }
}

export default new CurrencyService()
